export default [
  {
    path: '/deposit/:key?',
    name: 'depositIndex',
    component: () => import('@/views/deposit/DepositIndex.vue'),
    meta: {},
  },
];
